import { Injectable } from "@angular/core";

/**
 * Page-view tracker for the admin portal — intentionally a no-op.
 *
 * Historically this pushed `gtag('config', google_tracking_id, …)` on every
 * NavigationEnd, against the Universal Analytics property UA-147618337-2.
 * Google shut Universal Analytics down in July 2023, so those calls sent data
 * nowhere; the UA loader has also been removed from index.prod.html. The
 * tracking was additionally undisclosed in the cookie banner.
 *
 * The service and its wiring (AppComponent + app.module providers) are kept so
 * the call sites stay stable, but it no longer touches gtag or sets any
 * analytics storage. If a real GA4 tag is ever added, route it through
 * Consent Mode (the default-denied block already lives in index.prod.html) and
 * the consent banner before re-enabling page-view tracking here.
 */
@Injectable()
export class GoogleAnalyticsService {
  /** No-op: admin no longer ships an analytics tag. */
  public subscribe(): void {
    // intentionally empty
  }

  /** No-op: nothing to unsubscribe from. */
  public unsubscribe(): void {
    // intentionally empty
  }
}
